import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from '../../../store/configureStore';
import { FreeTrialModalHOC } from 'app/view/react_components/dialogs/freeTrialModal/hocs/FreeTrialModalHOC/FreeTrialModalHOC';

export class FreeTrialForm {
    el: HTMLElement;

    constructor () {
        if (this.el) this.remove();
        this.el = document.createElement('div');
        this.el.className = 'kanbanchi-free-trial-form-placeholder';
        document.body.append(this.el);
        this.render();
    }

    render () {
        ReactDOM.render(
            <Provider store={store}>
                <FreeTrialModalHOC />
            </Provider>
            , this.el);
    }

    remove () {
        if (!this.el) return;

        ReactDOM.unmountComponentAtNode(this.el);
        this.el.remove();
        this.el = null;
    }
}
